<template>
  <div class="fina_wrap">
    <grid-component type="行政管理系统" />
  </div>
</template>

<script>
import gridComponent from "../../components/gridComponent.vue";
import { getDict } from "@/utils/dict";
export default {
  components: { gridComponent },
  name: "systemIndex",
  created(){
    let flag = this.$store.state.dictOptions;
    if(flag && flag.spStatus.length>0){}else{
       getDict();
    }
  }
};
</script>
<style lang="less">
.fina_wrap {
  width: 100%;
  box-sizing: border-box;
  padding: 40px;
  padding-bottom: 180px;
}
</style>